export default __webpack_public_path__ + "static/media/system_01_04.73fb507c.jpg";